import { Routes } from '@angular/router';
import {infofragmentsResolver} from "./views/infofragments/infofragments.resolver";
import {homeResolver} from "./views/home/home.resolver";
import {invioMailResolver} from "./views/invio-mail/invio-mail.resolver";
import {mailInviateResolver} from "./views/mail-inviate/mail-inviate.resolver";
import {invioMailSingleResolver} from "./views/invio-mail/invio-mail-single.resolver";
import {authGuard} from "@shared/auth.guard";
import {mailArchiveResolver} from "./views/mail-archive/mail-archive.resolver";
import {mailArchiveSingleResolver} from "./views/mail-archive/mail-archive-single.resolver";
import {mailInviateSingleResolver} from "./views/mail-inviate/mail-inviate-single.resolver";
import {masterEditResolver} from "./views/master-edit/master-edit.resolver";

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./views/home/home.component').then((x) => x.HomeComponent),
    resolve: {home: homeResolver},
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'user',
    loadComponent: () => import('./views/mail-archive/mail-archive.component').then((x) => x.MailArchiveComponent),
    resolve: {user: mailArchiveResolver},
    runGuardsAndResolvers: "paramsOrQueryParamsChange",
    canActivate: [authGuard],
    data: {
      is_staff: false
    }
  },
  {
    path: 'user-mail/:id',
    loadComponent: () => import('./views/mail-archive/mail-archive-single.component').then((x) => x.MailArchiveSingleComponent),
    resolve: {user: mailArchiveSingleResolver},
    canActivate: [authGuard],
    data: {
      is_staff: false
    }
  },
  {
    path: 'mail-inviate/:id',
    loadComponent: () => import('./views/mail-inviate/mail-inviate-single.component').then((x) => x.MailInviateSingleComponent),
    resolve: {mail: mailInviateSingleResolver},
    runGuardsAndResolvers: "paramsChange",
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'mail-inviate',
    loadComponent: () => import('./views/mail-inviate/mail-inviate.component').then((x) => x.MailInviateComponent),
    resolve: {mail: mailInviateResolver},
    runGuardsAndResolvers: "paramsOrQueryParamsChange",
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'master/:category_id/:customer_id',
    loadComponent: () => import('./views/master-edit/master-edit.component').then((x) => x.MasterEditComponent),
    resolve: {mail: masterEditResolver},
    runGuardsAndResolvers: "paramsChange",
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'invio-mail/:category_id/:customer_id',

    loadComponent: () => import('./views/invio-mail/invio-mail-single.component').then((x) => x.InvioMailSingleComponent),
    resolve: {mail: invioMailSingleResolver},
    runGuardsAndResolvers: "paramsChange",
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'invio-mail',
    loadComponent: () => import('./views/invio-mail/invio-mail.component').then((x) => x.InvioMailComponent),
    resolve: {mail: invioMailResolver},
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'news/:channel',
    loadComponent: () => import('./views/infofragments/infofragments.component').then((x) => x.InfofragmentsComponent),
    resolve: {infofragments: infofragmentsResolver},
    runGuardsAndResolvers: 'pathParamsOrQueryParamsChange',
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: 'login',
    loadComponent: () => import('./views/login/login.component').then((x) => x.LoginComponent)
  },
  {
    path: 'logout',
    loadComponent: () => import('./views/login/logout.component').then((x) => x.LogoutComponent)
  },
  {
    path: 'error',
    loadComponent: () => import('./views/error-page/error-page.component').then((x) => x.ErrorPageComponent)
  },
  {
    path: 'crea-comunicazione',
    loadComponent: () => import('./views/comunicazioni-generali/crea-comunicazione.component').then((x) => x.CreaComunicazioneComponent),
    canActivate: [authGuard],
    data: {
      is_staff: true
    }
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login'
  },
];
